import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserDateFormat from '../../../../../components/user-date-format/index';
import { PrintedDateWithMarkPrintedCheckbox } from './printed-date-with-mark-printed-checkbox';
import classnames from 'classnames';
import style from './style.module.less';

const renderDateOrEmDash = (date) => {
  if (date) {
    return <UserDateFormat value={date} />;
  }
  return <span>--/--/----</span>;
};

export const BatchDetails = ({
  processedDate,
  processedByUserName,
  batchPrintDate,
  shipDate,
  shipFromName = '',
  isExternal = false,
  batchId,
}) => {
  return (
    <div className={style['batch-details']}>
      <div className={classnames(style['info-row'], style.info)}>
        <FormattedMessage
          defaultMessage='Processed By {processedByUserName}'
          description='Label batch processed by user name'
          id='+RDXCB'
          values={{ processedByUserName }}
        />
      </div>
      <div className={classnames(style['info-row'], style.info)}>
        <FormattedMessage
          defaultMessage='Processed Date {formattedProcessedDate}'
          description='Label batch processed date row'
          id='JCWuun'
          values={{
            formattedProcessedDate: renderDateOrEmDash(processedDate),
          }}
        />
      </div>
      <div className={classnames(style['info-row'], style.info)}>
        <FormattedMessage
          defaultMessage='Ship Date {formattedShippedDate}'
          description='Label Batch Shipped Date row'
          id='A6rUJ9'
          values={{
            formattedShippedDate: renderDateOrEmDash(shipDate),
          }}
        />
      </div>
      {!isExternal && !!shipFromName && (
        <div className={classnames(style['info-row'], style.info)}>
          <FormattedMessage
            defaultMessage='Ship From {shipFromName}'
            description='Label Batch Ship From row'
            id='DIeMQL'
            values={{ shipFromName }}
          />
        </div>
      )}
      <PrintedDateWithMarkPrintedCheckbox batchPrintDate={batchPrintDate} fulfillmentPlanSetId={batchId} />
    </div>
  );
};

BatchDetails.propTypes = {
  processedDate: PropTypes.string,
  processedByUserName: PropTypes.string,
  batchPrintDate: PropTypes.string,
  shipDate: PropTypes.string,
  shipFromName: PropTypes.string,
  isExternal: PropTypes.bool,
  batchId: PropTypes.string.isRequired,
};
